import { render } from "./MaskedInput.vue?vue&type=template&id=08bfcfdf"
import script from "./MaskedInput.vue?vue&type=script&lang=js"
export * from "./MaskedInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__